export default __webpack_public_path__ + "static/media/Strangler's Belt of Charred Earth.6081ab6a.jpg";